<template>
  <MobileGoogleAdsInterstitialPopup
    path="/22777916944/RTBGo_Mobile_Web_PopUp_Banner_320x250"
    :size="[320, 250]"
    id="div-gpt-ad-1751603181609-0"
    style="margin:0 auto;"
  />
</template>

<script>
import MobileGoogleAdsInterstitialPopup from "../../../popup/mobileGoogleAdsInterstitialPopup.vue";

export default {
  data() {
    return {};
  },
  components: {
    MobileGoogleAdsInterstitialPopup,
  },
};
</script>

<style scoped></style>
